// @ts-strict-ignore
import React from 'react'
import { useEntity } from '../helpers/selectors'
import { Container } from '../helpers/react'
import Hero from './hero-element'
import { cf2imgix } from '../helpers/imgix-image'
import Breadcrumbs from '../breadcrumbs.connected'
import Grid from './grid-from-json.connected'

const HeroModule = (props) => {
  const image = useEntity(props.image)

  const imagePosition =
    props.imagePosition === 'Money homepage'
      ? {
          position: {
            bottom: 0,
            right: 0,
            transform: 'scale(1.4) translate(40%, 5%)',
          },
          imageType: 'img',
          displayOnMobile: true,
        }
      : {
          position: {
            backgroundSize: ['auto 90%'],
            backgroundPosition: ['right 0 bottom 0'],
          },
          imageType: 'background',
        }

  const breadcrumbs = <Breadcrumbs entity={props.breadcrumbs} />

  return (
    <Hero
      breadcrumbs={props.breadcrumbs && breadcrumbs}
      container={Container}
      fgImage={cf2imgix(image?.file?.url)}
      fgImagePosition={imagePosition.position}
      fgImageType={imagePosition.imageType}
      fgImageOnMobile={props.displayImageOnMobile}
      {...(imagePosition === 'Money homepage' ? {} : { variant: props.variant })}
    >
      <Grid {...props} />
    </Hero>
  )
}

export default HeroModule
